import { gsap } from 'gsap'
import { onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const imageWrap = element.querySelector(
    '.content_showcase_img_wrap'
  ) as HTMLElement
  const image = element.querySelector(
    '.content_showcase_img_wrap img'
  ) as HTMLImageElement

  if (!imageWrap || !image) return

  let isHovering = false
  const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)'

  const handleMouseEnter = () => {
    isHovering = true

    gsap.to(image, {
      scale: 1.04,
      duration: 0.7,
      ease: easeOutQuart,
    })
  }

  const handleMouseMove = (e: MouseEvent) => {
    if (!isHovering) return

    const rect = imageWrap.getBoundingClientRect()
    const x = e.clientX - rect.left
    const y = e.clientY - rect.top

    const centerX = rect.width / 2
    const centerY = rect.height / 2

    const moveX = ((x - centerX) / centerX) * 4
    const moveY = ((y - centerY) / centerY) * 4

    gsap.to(image, {
      x: moveX,
      y: moveY,
      duration: 0.5,
      ease: easeOutQuart,
    })
  }

  const handleMouseLeave = () => {
    isHovering = false

    gsap.to(image, {
      scale: 1,
      x: 0,
      y: 0,
      duration: 0.6,
      ease: easeOutQuart,
    })
  }

  onMount(() => {
    const mm = gsap.matchMedia()

    mm.add('(hover: hover) and (pointer: fine)', () => {
      element.addEventListener('mouseenter', handleMouseEnter)
      element.addEventListener('mousemove', handleMouseMove)
      element.addEventListener('mouseleave', handleMouseLeave)

      return () => {
        element.removeEventListener('mouseenter', handleMouseEnter)
        element.removeEventListener('mousemove', handleMouseMove)
        element.removeEventListener('mouseleave', handleMouseLeave)
      }
    })
  })

  onDestroy(() => {
    element.removeEventListener('mouseenter', handleMouseEnter)
    element.removeEventListener('mousemove', handleMouseMove)
    element.removeEventListener('mouseleave', handleMouseLeave)
  })
}
